var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-0 pt-0",attrs:{"no-gutter":"","fluid":""}},[_c('ticket-details-component'),_c('ticket-history-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }